import { FgBlockType } from '../../block-type.js';
import { FgType } from '../../types.js';
import { getDataValue, setDataValue } from '../../runtime.js';
import { sockOut, sockIn } from '../../sockets.js';
import { fgTrunc } from '../../fg-math.js';

const truncDef = {
  type: FgBlockType.Trunc,
  build: () => ({
    dataIn: [sockIn("a", FgType.Any)],
    dataOut: [sockOut("value", FgType.Any)]
  }),
  updateOutputs(block, ctx, env) {
    const a = getDataValue(ctx, env, block, "a");
    setDataValue(ctx, block, "value", fgTrunc(a));
  }
};

export { truncDef };
//# sourceMappingURL=trunc.js.map
